//$( document ).ready(function() { 
function check_sponsor(){
var cust_id= document.getElementById('customer_number').innerHTML;
var cust_id=cust_id.replace("<a href=\"javascript: void(0)\">", "");
var cust_id = cust_id.replace("</a>", ""); 

var product_id= document.getElementById('spon_product_id').innerHTML;
var product_id = product_id.replace("<a href=\"javascript: void(0)\">", "");
var product_id = product_id.replace("</a>", ""); 


  if (cust_id.length>0 && product_id.length>0){
    
           $.post("https://buylocalus.com/apps/blusapp/get_sponsor.php",{cust_id:cust_id,product_id:product_id},function(data){

            
           if (data==1){
var atcex=document.getElementById("atc_box");
             if (atcex){
              document.getElementById("atc_box").style.display="none" ; 
             }

             var asex=document.getElementById("already_spon");
             if (asex){
              document.getElementById("already_spon").style.display="block" ; 
             }
             
           }
        

           });
  }
}
//});  

$( document ).ready(function() { 
jQuery.getJSON('/cart.js', function(cart) {
   var cart_count=cart.items.length;
  
   var product_id= document.getElementById('spon_product_id').innerHTML;
    var product_id = product_id.replace("<a href=\"javascript: void(0)\">", "");
    var product_id = product_id.replace("</a>", ""); 

 
  
  document.getElementById("cartcount").innerHTML=cart_count;
  
   if (cart_count>0){
     
    for (var i = 0, len = cart_count; i < len; i++) {
    
      if (cart.items[i]['product_id']==product_id){
      var atcex=document.getElementById("atc_box");
             if (atcex){
              document.getElementById("atc_box").style.display="none" ; 
             }
        var icex=document.getElementById("in_cart");
             if (icex){
              document.getElementById("in_cart").style.display="block" ; 
             }
        
      }
    }
   }
  
 check_sponsor(); 
});
  
  });

